export function adjustHeaderHeight() {
  var isYieldMonitorPage = document.querySelector('.yield-monitor');
  var investmentsDesktopContent = document.querySelector('#investments-desktop .site-header__submenu-inner .tabs__content.tab-content');
  var headerHeight = $("header.site-header").outerHeight();
  var AlertBArsCumilativeHeights = $(".alert-bar").toArray().reduce((prev, curr) => { return $(curr).height() + prev }, 0);

  $("#root > .sticky-wrapper").height(headerHeight + AlertBArsCumilativeHeights);
  $("body > .bs4-nav:first").height(headerHeight + AlertBArsCumilativeHeights);
  if ($(".fund-page-secondary-nav-wrp").length == 1 || $(".secondary-nav").length == 1) {
      $(".fund-page-secondary-nav-wrp").css("top", (headerHeight + AlertBArsCumilativeHeights));
      $(".secondary-nav").css("top", (headerHeight + AlertBArsCumilativeHeights));
  }
  if ($("body.page-class-insights").length > 0) {
      if (typeof GenerateAnchoredBlocks === "function") {
          GenerateAnchoredBlocks(true);
      }
  }

  //Dispatch an event on the Document level so everyone adjusting their heights (esp. React Secondary Navs) can adjust automatically.
  const HeaderheightEvent = new CustomEvent("headerHeightEvent", {
      detail: {
          headerHeight: headerHeight,
          cumilativeAlertBarsHeight: AlertBArsCumilativeHeights
      }
  })

  if (isYieldMonitorPage) {
      var tables = document.querySelectorAll('.fund-explorer-table');
      var finalHeight = headerHeight + 41;

      tables.forEach(table => {
          var tHead = table.querySelector('.table thead');
          if (!tHead) return;
          
          setTimeout(() => {
              tHead.style['top'] = finalHeight + 'px';
          }, 351);
      });
  }

  if (investmentsDesktopContent) {
      var contentHeight = headerHeight + 91;

      setTimeout(() => {
          investmentsDesktopContent.style['max-height'] = 'calc(100vh - ' + contentHeight + 'px)';
      }, 351);
  }
  
  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  document.dispatchEvent(HeaderheightEvent);
  document.addEventListener("headerHeightEvent", function(e) {
      const height = e.detail && e.detail.cumilativeAlertBarsHeight !== undefined
          ? e.detail.cumilativeAlertBarsHeight
          : 0;
      document.documentElement.style.setProperty('--alert-bars-height', `${height}px`);
  });
}